import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=788c6304&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=788c6304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c6304",
  null
  
)

export default component.exports